export default __webpack_public_path__ + "static/media/github.22cfdd1c.png";